// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionC_comp__mVQrb"};